import { useThemeStore } from '../stores/themeStore';
import { useSTDisplayStore } from '../stores/stDisplayStore';
import { useTourStore } from '../stores/tourStore';

/**
 * Re-reads the settings the stores hold (theme, Selective Touch display, tours) for this user and
 * applies them. Used when where a PSI user's settings live changes under a page that is already up:
 * the server's shared values arrived, sharing was turned off or on for this connection, or the
 * shared settings were started over (hooks/sharedPrefs.ts). Settings read through usePreference
 * follow on their own.
 */
export function reapplyUserSettings(userId: number): void {
  if (userId <= 0) return;
  useThemeStore.getState().syncWithUser(userId);
  useSTDisplayStore.getState().syncWithUser(userId);
  useTourStore.getState().loadFromPrefs(userId);
}
